<template>
  <div>
    <a-form :form="form" id="form">
      <a-form-item label="Handed Over">
        <a-radio-group
          button-style="solid"
          @change="selectRadioUsedFor"
          v-model="usedfor"
          :disabled="used_for_status && isAssetModal=='no'"
        >
          <a-radio-button value="unitkelola" v-if="isAssetModal === 'yes'"> Unit Pengelola </a-radio-button>
          <a-radio-button value="gudang" v-if="isAssetModal === 'no'"> Gudang </a-radio-button>
          <a-radio-button value="tlc"> TLC </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item v-if="this.usedfor === 'unitkelola'" label="Unit Manage">
        <a-select
          showSearch
          allowClear
          labelInValue
          :filter-option="filterOption"
          option-filter-prop="children"
          @change="handleSelectedUnitKelola"
          v-decorator="['pengelola_default', { rules: [{ required: false }] }]"
        >
          <a-select-option
            v-for="item in daftarUnitKelola"
            :key="item.aset_unit_id"
            :value="item.aset_unit_id"
            >{{ item.aset_unit_nm }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-if="this.usedfor === 'gudang'" label="Storage Location">
        <a-select
          showSearch
          allowClear
          labelInValue
          :filter-option="filterOption"
          option-filter-prop="children"
          @change="handleSelectedStorage"
          v-decorator="['gudang_default', { rules: [{ required: false }] }]"
        >
          <a-select-option
            v-for="item in daftarGudang"
            :key="item.gudang_id"
            :value="item.gudang_id"
            >{{ item.gudang_nm }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-if="this.usedfor === 'tlc'" label="TLC">
        <a-select
          showSearch
          allowClear
          labelInValue
          :filter-option="filterOption"
          option-filter-prop="children"
          @change="handleSelectedStoragetlc"
          v-decorator="['tlc_default', { rules: [{ required: false }] }]"
        >
          <a-select-option v-for="user in AllKaryawan" :key="user.tlc"
            >{{ user.tlc }} - {{ user.nama }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-table
          :columns="columnsShipmentReceive"
          :dataSource="tempDataReceive"
          size="small"
          :pagination="pagination"
          bordered
        >
          <span slot="item_name" slot-scope="item">
            <h4>{{ item.type_item=="1" ? "[ASET]" : "[ITEM]" }}</h4>
            <h4>{{ item.item_name }}</h4>
            {{ item.item_pn ? "PN : " + item.item_pn : "" }}<br />
            {{ item.kd_anggaran }}<br />
            {{ item.dtl_pp_nm }}
          </span>
          <span slot="item_name_receive" slot-scope="item">
            <h4 class="margin-remove">{{ item.item_name_receive }}</h4>
            <template v-if="item.tlc">
              {{ item.item_name }}
            </template>
            <template v-else>
              {{ item.item_pn_receive ? "PN : " + item.item_pn_receive : "" }}
            </template>
          </span>
          <span slot="price_unit" slot-scope="item">
            {{ formatCurrency('IDR',item.price) }} / {{item.unit ? item.unit : item.satuan}}
          </span>
          <template
            v-for="col in ['quantity', 'gudang_name']"
            :slot="col"
            slot-scope="text"
          >
            <div :key="col">
              <div v-if="col === 'quantity'">
                <template>{{ text.quantity }} {{ text.satuan }} </template>
              </div>

              <div v-else-if="col === 'gudang_name'">
                <template
                  >{{ text.tlc_name ? text.tlc_name : (text.gudang_name ? text.gudang_name : text.unit_kelola_name) }}
                </template>
              </div>
            </div>
          </template>

          <template slot="action" slot-scope="text, record, index">
            <a-button
              @click="handleEditPopover(record)"
              :disabled="!record.gudang_id && !record.tlc && !record.unit_kelola_id"
              type="primary"
              icon="edit"
            >
              Edit
            </a-button>
          </template>
        </a-table>
    </a-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  props: ["isAssetModalParent","formShipmentReceiveParent","tempDataReceiveParent",
  "used_for_status","usedforParent","daftarUnitKelola","daftarGudang","AllKaryawan",
  "columnsShipmentReceive","pagination"],
  name: "ReceiveItemAset",
  mixins: [CurrencyFormat,GlobalMethod],
  data() {
    return {
      form: this.$form.createForm(this),
      isAssetModal: null,
      formShipmentReceive: null,
      tempDataReceive:null,
      usedfor:null,
    };
  },
  created() {
    // this.FETCH_GA();
    // this.FETCH_VPM();
  },
  computed: {
    ...mapGetters(["getAuth",]),
    // initialData: function () {
    //   if (this.collectData.informasi === undefined || this.collectData.informasi.length <= 0) {
    //     return {
    //       catatan: "",
    //     };
    //   } else {
    //     return {
    //       catatan: this.collectData.informasi.catatan,
    //     };
    //   }
    // },
    // listApproval(){
    //   if (this.mode == 'Edit'){
    //     return this.approval
    //   }else{
    //     return this.informasi.approval
    //   }
    // }
  },
  watch: {
    isAssetModalParent(){
      if (this.isAssetModalParent) {
        this.isAssetModal = this.isAssetModalParent;
        this.filteredDataReceive(this.isAssetModal=="yes"? "1" : "0");
      }
    }
  },
  mounted() {
    this.isAssetModal = this.isAssetModalParent;
    this.formShipmentReceive = this.formShipmentReceiveParent;
    this.filteredDataReceive(this.isAssetModal=="yes"? "1" : "0");
    this.usedfor = this.usedforParent;
  },
  methods: {
    moment,
    handleRef() {
      this.form.validateFields((err, values) => {
        let isAssetModals = this.isAssetModal=="yes"? "1" : "0";
        let tdta = _.filter(
          this.tempDataReceiveParent,
          (el) => el.type_item==isAssetModals && el.item_name_receive==null
          && el.tlc_name==null
        );
        console.log(tdta)

        if (tdta.length>0){
          this.displayMessageValue(
            "basic-error",
            "Please click Edit button to edit column Item Receive!"
          );
        }else{
          Event.$emit("poReceiveItemAset", true);
        }
      });
    },
    selectRadioUsedFor(e) {
      if (e.target.value === "gudang") {
        this.form.setFieldsValue({ gudang_default: undefined });
        this.handleSelectedStorage(undefined);
      } else if(e.target.value === "unitkelola"){
        this.form.setFieldsValue({ pengelola_default: undefined });
        this.handleSelectedUnitKelola(undefined);
      }else {
        this.form.setFieldsValue({ tlc_default: undefined });
        this.handleSelectedStoragetlc(undefined);
      }
    },
    handleSelectedStorage(val) {
      Event.$emit("poReceivehandleSelectedStorage", val);
    },
    handleSelectedUnitKelola(val){
      Event.$emit("poReceivehandleSelectedUnitKelola", val);
    },
    handleSelectedStoragetlc(val) {   
      let isAssetModals = this.isAssetModal=="yes"? "1" : "0";
      Event.$emit("poReceivehandleSelectedStoragetlc", {val,isAssetModals:isAssetModals});
    },
    handleEditPopover(val){
      Event.$emit("poReceivehandleEditPopover", val);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filteredDataReceive(value){
      this.tempDataReceive = _.filter(
          this.tempDataReceiveParent,
          (el) => el.type_item==value
        );
      if (value=="0"){
        this.usedfor = "gudang";
        this.form.setFieldsValue({
          gudang_default: null,
        });
      }else{
        this.usedfor = "unitkelola";
        this.form.setFieldsValue({
          pengelola_default: null,
        });
      }
    }
  },
};
</script>

<style lang="less">
.group-flex {
  display: flex;
  margin-top: @margin / 2;
}
</style>
